import { useEffect, useRef } from "react";

// Slow auto-scrolling strip that still allows manual swipe / trackpad scrolling.
export default function AutoScroll({ children, speed = 0.4, className = "", testid }) {
  const box = useRef(null);
  const until = useRef(0);
  useEffect(() => {
    const el = box.current;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    let pos = el.scrollLeft;
    const id = setInterval(() => {
      if (Date.now() < until.current) { pos = el.scrollLeft; return; }
      const half = el.scrollWidth / 2;
      pos += speed;
      if (pos >= half) pos -= half;
      el.scrollLeft = pos;
    }, 20);
    return () => clearInterval(id);
  }, [speed]);
  const hold = (ms) => () => { until.current = Date.now() + ms; };
  return (
    <div ref={box} onWheel={hold(2500)} onTouchStart={hold(4000)} onMouseMove={hold(400)} data-noreveal data-testid={testid}
      className={`flex overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden ${className}`}>
      {children}{children}
    </div>
  );
}
